//Import required libraries
import React from "react";
import { Route, Switch } from "react-router-dom";

//Import custom components
import Photographer from "./pages/Photographer";
import PhotographerAdmin from "./pages/PhotographerAdmin";
import Error from "./pages/Error";

const App = () => {
  return (
    <div className="App">
      <main>
        <Switch>
          <Route path="/" component={Photographer} exact />
          <Route
            path="/admin"
            component={PhotographerAdmin}
            exact
          />
          <Route component={Error} />
        </Switch>
      </main>
    </div>
  );
};

export default App;
